import React from "react";

import FormCard from "@/components/formInputFields/FormCard";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";
import FormDateInput from "@/components/formInputFields/FormDateInput";

const DiscountDateSection = ({ register, errors }) => {
  return (
    <FormCard className="w-full max-w-3xl">
      <FormSectionTitle>Discount Duration</FormSectionTitle>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormDateInput
          name="discountStartDate"
          label="Start Date"
          withTime
          required
          register={register}
          error={errors.discountStartDate}
        />

        <FormDateInput
          name="discountEndDate"
          label="End Date"
          withTime
          required
          register={register}
          error={errors.discountEndDate}
        />
      </div>
    </FormCard>
  );
};

export default DiscountDateSection;